import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import { GetColourArray } from "./Common";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ColourChip from "./ColourChip";

import { ChromePicker } from "react-color";

import InputBase from "@material-ui/core/InputBase";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import BSL_ControlContainer from "./BSL_ControlContainer";

const BSL_Input = withStyles((theme) => ({
    root: {
        border: "1px solid #6b8799",
        width: "100%",
        "label + &": {
            marginTop: theme.spacing(3),
        },
        "&.Mui-focused": {
            border: "2px solid " + Palette.Control.DarkBlueTrans,
        },
        "& .mini": {
            display: "none",
        },
        "& .chrome-picker": {
            display: "none",
        },
        "& .colour-chip": {
            display: "block",
        },
        "& .MuiTabs-root": {
            display: "none",
        },
        "&.Mui-disabled": {
            opacity: 0.5,
            border: "none",
        },
    },
    input: {
        borderRadius: 2,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "0px solid #6b8799",
        padding: "4px 26px 4px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        textAlign: "start",
        width: "100%",
        // Use the system font instead of the default Roboto font.
        font: "200 14px " + theme.typography.fontFamily,
        "&:focus": {
            // borderRadius: 4,
            border: "0px solid #002D62",
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "0px solid #002D62",
        },
        "&.Mui-focused": {
            border: "0px solid #002D62",
        },
    },
}))(InputBase);

export const BSL_MenuItem = withStyles((theme) => ({
    root: {
        font: "14px " + theme.typography.fontFamily,
        padding: "4px 14px 4px 24px",
        minHeight: "32px",

        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                // color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

export const ColourPicker_MenuItem = withStyles((theme) => ({
    root: {
        font: "14px " + theme.typography.fontFamily,
        padding: "4px 14px 4px 24px",
        flexDirection: "column",
        minHeight: '"32px"',
        "&:hover": {
            // backgroundColor: Palette.Control.LightGrey,
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                // color: theme.palette.common.white,
            },
        },
        "& .colour-chip": {
            display: "none !important",
        },
    },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
    root: {
        textShadow: "none",
    },
    input: {
        flex: "1",
        font: "14px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
    },
    input_tight: {
        font: "13px " + theme.typography.fontFamily,
        padding: "2px 0px 0px 0px",
    },
    margin: {
        margin: "2px 2px 0px 8px",
    },
    menu_paper: {
        border: "1px solid " + Palette.Control.DarkBlueTrans,
        // paddingLeft: "17px",
        "& .chrome-picker": {
            boxShadow: "none !important",
        },
        "& .Mui-disabled": {
            opacity: "1",
            cursor: "auto",
            pointerEvents: "inherit",
            backgroundColor: "inherit",
            boxShadow: "none !important",
        },
        "& .MuiListItem-button:hover": {
            backgroundColor: "inherit",
        },
    },
    thumbnail: {
        width: "80px",
        paddingRight: "10px",
        objectFit: "contain",
        height: "24px",
    },
    disabled: {
        color: Palette.Control.Grey,
    },
}));

function AddRegistered(colour) {
    if (!colour || !colour.includes) return colour;
    if (colour.includes("Basalt")) colour = colour.replace("Basalt", "Basalt®");
    if (colour.includes("Cove")) colour = colour.replace("Cove", "Cove®");
    if (colour.includes("Dune")) colour = colour.replace("Dune", "Dune®");
    if (colour.includes("Evening Haze")) colour = colour.replace("Evening Haze", "Evening Haze®");
    if (colour.includes("Gully")) colour = colour.replace("Gully", "Gully®");
    if (colour.includes("Ironstone")) colour = colour.replace("Ironstone", "Ironstone®");
    if (colour.includes("Jasper")) colour = colour.replace("Jasper", "Jasper®");
    if (colour.includes("Mangrove")) colour = colour.replace("Mangrove", "Mangrove®");
    if (colour.includes("Monument")) colour = colour.replace("Monument", "Monument®");
    if (colour.includes("Shale Grey")) colour = colour.replace("Surfmist", "Surfmist™");
    if (colour.includes("Surfmist")) colour = colour.replaceAll("Surfmist", "Surfmist®");
    if (colour.includes("Terrain")) colour = colour.replace("Terrain", "Terrain®");
    if (colour.includes("Wallaby")) colour = colour.replace("Wallaby", "Wallaby®");
    if (colour.includes("Windspray")) colour = colour.replace("Windspray", "Windspray®");
    if (colour.includes("Thredbo White")) colour = colour.replace("Thredbo White", "Thredbo White®");

    if (colour.includes("Classic Cream")) colour = colour.replaceAll("Classic Cream", "Classic Cream™");
    if (colour.includes("Cottage Green")) colour = colour.replace("Cottage Green", "Cottage Green®");
    if (colour.includes("Deep Ocean")) colour = colour.replace("Deep Ocean", "Deep Ocean®");
    if (colour.includes("Manor Red")) colour = colour.replace("Manor Red", "Manor Red®");
    if (colour.includes("Night Sky")) colour = colour.replace("Night Sky", "Night Sky®");
    if (colour.includes("Pale Eucalypt")) colour = colour.replace("Pale Eucalypt", "Pale Eucalypt®");
    if (colour.includes("Paperbark")) colour = colour.replaceAll("Paperbark", "Paperbark®");
    if (colour.includes("Woodland Grey")) colour = colour.replace("Woodland Grey", "Woodland Grey®");

    if (colour.includes("TBA")) colour = "UNDECIDED";
    return colour;
}

export default function BSL_ColourSelector(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const config = useSelector((state) => state.config);

    const [open, setOpen] = React.useState(false);
    const [color, setColor] = React.useState(props.value ? props.value : "#ffffff");
    const [collection_tab_index, setcollection_tab_index] = React.useState(0);

    const handleChange = (event) => {
        let new_colour = event.target.value;
        if (props.onChange) {
            let change = props.onChange;
            setTimeout(() => {
                // let new_colour = tinycolor(new_color.rgb);
                // );
                change(new_colour);
            }, 0);
        }
    };
    const handleChangeCustom = (colour) => {
        let new_colour = colour;
        setColor(new_colour.hex);
        if (props.onChange) {
            let change = props.onChange;
            setTimeout(() => {
                // let new_colour = tinycolor(new_color.rgb);
                // );
                change(new_colour.hex);
            }, 0);
        }
    };

    function hasSomeParentTheClass(element, classname) {
        if (!element) return false;
        if (element?.className && element?.className?.split && element?.className?.split(" ").indexOf(classname) >= 0)
            return true;
        return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
    }

    const {
        label,
        value,
        style,
        dark,
        width,
        undecided,
        defaultColour,
        useUndecided = false,
        colourMatch,
        reverseColours = false,
    } = props;

    let selectedColour = props.value;
    if (undecided) selectedColour = "TBA";

    let menu_items = [];
    if (props.placeholder)
        menu_items.push(
            <BSL_MenuItem value="" disabled>
                {props.placeholder}
            </BSL_MenuItem>
        );

    //
    let colours = GetColourArray(props.colourList, config.colour_arrays);

    if (colours !== []) {
        // if (colours.length > 1 && useUndecided) {
        //     if (defaultColour !== null) menu_items.push(<BSL_MenuItem key={"TBA"} data-defaultcolour={defaultColour} value="TBA"><ColourChip colour={defaultColour} width="1rem" /><span className={props.mini ? "mini" : ""}>&nbsp;UNDECIDED</span></BSL_MenuItem>);
        //     else menu_items.push(<BSL_MenuItem key={"TBA"} value="TBA"><span className={props.mini ? "mini" : ""}>UNDECIDED</span></BSL_MenuItem>);
        // }
        for (var colour of colours) {
            let colour_trim = colour.trim();
            let display_colour = colour_trim;
            let display_text = AddRegistered(colour_trim);

            if (colourMatch && colour_trim in colourMatch) {
                if (colours.includes(colourMatch[colour_trim])) {
                    display_colour = colourMatch[colour_trim];
                    display_text = display_text + " (" + AddRegistered(colourMatch[colour_trim]) + ")";
                } else if (colourMatch[colour_trim].includes("/") || props.allowInvalid) {
                    let single_colour = colourMatch[colour_trim].split("/")[0];
                    if (colours.includes(single_colour) || props.allowInvalid) {
                        display_colour = single_colour;
                        display_text = display_text + " (" + AddRegistered(single_colour) + ")";
                    } else {
                        single_colour = colourMatch[colour_trim].split("/")[1];
                        if (colours.includes(single_colour) || props.allowInvalid) {
                            display_colour = single_colour;
                            display_text = display_text + " (" + AddRegistered(single_colour) + ")";
                        } else {
                            // Not a valid colour from list, show colour as invalid option
                            display_colour = "TBA";
                            display_text = display_text + ` (${colourMatch[colour_trim]} - Not Valid)`;
                        }
                    }
                } else {
                    // Not a valid colour from list, show colour as invalid option
                    display_colour = "TBA";
                    display_text = display_text + ` (${colourMatch[colour_trim]} - Not Valid)`;
                }
            }

            menu_items.push(
                <BSL_MenuItem key={colour_trim} value={colour_trim}>
                    <ColourChip colour={display_colour} reverse={reverseColours} width="1rem" />
                    <span className={props.mini ? "mini" : ""}>&nbsp;{display_text}</span>
                </BSL_MenuItem>
            );
        }

        if (!colours.includes(selectedColour) && colours.includes(selectedColour + "/Grey")) {
            selectedColour = selectedColour + "/Grey";
        }
    }

    return (
        <BSL_ControlContainer {...props}>
            {props.custom_select && (
                <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    variant="outlined"
                    value={"picker"}
                    disabled={props.disabled}
                    displayEmpty={props.placeholder}
                    // onChange={props.onChange}
                    MenuProps={{
                        classes: {
                            paper: classes.menu_paper,
                        },
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        style: {
                            marginTop: "5px",
                            marginLeft: "-1px",
                            border: "1px solid #6b8799",
                        },
                        getContentAnchorEl: null,
                    }}
                    inputProps={{
                        classes: {
                            root: classes.root,
                        },
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={(e) => {
                        if (hasSomeParentTheClass(e.target, "chrome-picker")) return;
                        if (hasSomeParentTheClass(e.target, "color-picker")) return;
                        setOpen(false);
                        if (props.onClose) {
                            props.onClose(color);
                        }
                    }}
                    open={open}
                    input={<BSL_Input />}
                >
                    <ColourPicker_MenuItem
                        className="color-picker"
                        disabled
                        value="picker"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.bubbles = false;
                        }}
                    >
                        <ColourChip className="colour-chip" colour={color} width="1rem" />
                        {/* <StyledTabs style={{ flex: "1" }} value={collection_tab_index} onChange={(event, newValue) => setcollection_tab_index(newValue)}>
                                <StyledTab label={"Colorbond"} />
                                <StyledTab label={"Custom"} />
                            </StyledTabs> */}
                        <ChromePicker
                            disableAlpha={true}
                            color={color}
                            onChange={handleChangeCustom}
                            // presetColors={colour_presets}
                        />
                        {props.mini ? "" : colourHexToName(color)}
                    </ColourPicker_MenuItem>
                </Select>
            )}
            {!props.custom_select && (
                <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    variant="outlined"
                    value={value}
                    disabled={props.disabled}
                    displayEmpty={props.placeholder}
                    onChange={handleChange}
                    MenuProps={{
                        classes: {
                            paper: classes.menu_paper,
                        },
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        style: {
                            marginTop: "5px",
                            marginLeft: "-1px",
                            border: "1px solid #6b8799",
                        },
                        getContentAnchorEl: null,
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    input={<BSL_Input />}
                >
                    {menu_items}
                </Select>
            )}
        </BSL_ControlContainer>
    );
}

const colours = {
    "#f0f8ff": "AliceBlue",
    "#faebd7": "AntiqueWhite",
    "#faebd7": "Aqua",
    "#7fffd4": "Aquamarine",
    "#f0ffff": "Azure",
    "#f5f5dc": "Beige",
    "#ffe4c4": "Bisque",
    "#000000": "Black",
    "#ffebcd": "BlanchedAlmond",
    "#0000ff": "Blue",
    "#8a2be2": "BlueViolet",
    "#a52a2a": "Brown",
    "#deb887": "BurlyWood",
    "#5f9ea0": "CadetBlue",
    "#7fff00": "Chartreuse",
    "#d2691e": "Chocolate",
    "#ff7f50": "Coral",
    "#6495ed": "CornflowerBlue",
    "#fff8dc": "Cornsilk",
    "#dc143c": "Crimson",
    "#00ffff": "Cyan",
    "#00008b": "DarkBlue",
    "#008b8b": "DarkCyan",
    "#b8860b": "DarkGoldenRod",
    "#a9a9a9": "DarkGray",
    "#006400": "DarkGrey",
    "#006400": "DarkGreen",
    "#bdb76b": "DarkKhaki",
    "#8b008b": "DarkMagenta",
    "#556b2f": "DarkOliveGreen",
    "#ff8c00": "DarkOrange",
    "#9932cc": "DarkOrchid",
    "#8b0000": "DarkRed",
    "#e9967a": "DarkSalmon",
    "#8fbc8f": "DarkSeaGreen",
    "#483d8b": "DarkSlateBlue",
    "#2f4f4f": "DarkSlateGray",
    "#2f4f4f": "DarkSlateGrey",
    "#00ced1": "DarkTurquoise",
    "#9400d3": "DarkViolet",
    "#ff1493": "DeepPink",
    "#00bfff": "DeepSkyBlue",
    "#696969": "DimGray",
    "#696969": "DimGrey",
    "#1e90ff": "DodgerBlue",
    "#b22222": "FireBrick",
    "#fffaf0": "FloralWhite",
    "#228b22": "ForestGreen",
    "#228b22": "Fuchsia",
    "#dcdcdc": "Gainsboro",
    "#f8f8ff": "GhostWhite",
    "#ffd700": "Gold",
    "#daa520": "GoldenRod",
    "#808080": "Gray",
    "#adff2f": "Grey",
    "#008000": "Green",
    "#adff2f": "GreenYellow",
    "#f0fff0": "HoneyDew",
    "#ff69b4": "HotPink",
    "#cd5c5c": "IndianRed",
    "#4b0082": "Indigo",
    "#fffff0": "Ivory",
    "#f0e68c": "Khaki",
    "#e6e6fa": "Lavender",
    "#fff0f5": "LavenderBlush",
    "#7cfc00": "LawnGreen",
    "#fffacd": "LemonChiffon",
    "#add8e6": "LightBlue",
    "#f08080": "LightCoral",
    "#e0ffff": "LightCyan",
    "#fafad2": "LightGoldenRodYellow",
    "#fafad2": "LightGray",
    "#d3d3d3": "LightGrey",
    "#90ee90": "LightGreen",
    "#ffb6c1": "LightPink",
    "#ffa07a": "LightSalmon",
    "#20b2aa": "LightSeaGreen",
    "#87cefa": "LightSkyBlue",
    "#778899": "LightSlateGray",
    "#778899": "LightSlateGrey",
    "#b0c4de": "LightSteelBlue",
    "#ffffe0": "LightYellow",
    "#00ff00": "Lime",
    "#32cd32": "LimeGreen",
    "#faf0e6": "Linen",
    "#ff00ff": "Magenta",
    "#800000": "Maroon",
    "#66cdaa": "MediumAquaMarine",
    "#0000cd": "MediumBlue",
    "#ba55d3": "MediumOrchid",
    "#9370d8": "MediumPurple",
    "#3cb371": "MediumSeaGreen",
    "#7b68ee": "MediumSlateBlue",
    "#00fa9a": "MediumSpringGreen",
    "#48d1cc": "MediumTurquoise",
    "#c71585": "MediumVioletRed",
    "#191970": "MidnightBlue",
    "#f5fffa": "MintCream",
    "#ffe4e1": "MistyRose",
    "#ffe4b5": "Moccasin",
    "#ffdead": "NavajoWhite",
    "#000080": "Navy",
    "#fdf5e6": "OldLace",
    "#808000": "Olive",
    "#6b8e23": "OliveDrab",
    "#ffa500": "Orange",
    "#ff4500": "OrangeRed",
    "#da70d6": "Orchid",
    "#eee8aa": "PaleGoldenRod",
    "#98fb98": "PaleGreen",
    "#afeeee": "PaleTurquoise",
    "#d87093": "PaleVioletRed",
    "#ffefd5": "PapayaWhip",
    "#ffdab9": "PeachPuff",
    "#cd853f": "Peru",
    "#ffc0cb": "Pink",
    "#dda0dd": "Plum",
    "#b0e0e6": "PowderBlue",
    "#800080": "Purple",
    "#663399": "RebeccaPurple",
    "#ff0000": "Red",
    "#bc8f8f": "RosyBrown",
    "#4169e1": "RoyalBlue",
    "#8b4513": "SaddleBrown",
    "#fa8072": "Salmon",
    "#f4a460": "SandyBrown",
    "#2e8b57": "SeaGreen",
    "#fff5ee": "SeaShell",
    "#a0522d": "Sienna",
    "#c0c0c0": "Silver",
    "#87ceeb": "SkyBlue",
    "#6a5acd": "SlateBlue",
    "#708090": "SlateGray",
    "#708090": "SlateGrey",
    "#fffafa": "Snow",
    "#00ff7f": "SpringGreen",
    "#4682b4": "SteelBlue",
    "#d2b48c": "Tan",
    "#008080": "Teal",
    "#d8bfd8": "Thistle",
    "#ff6347": "Tomato",
    "#40e0d0": "Turquoise",
    "#ee82ee": "Violet",
    "#f5deb3": "Wheat",
    "#ffffff": "White",
    "#f5f5f5": "WhiteSmoke",
    "#ffff00": "Yellow",
    "#9acd32": "YellowGreen",
};
function colourHexToName(colour) {
    if (typeof colours[colour.toLowerCase()] != "undefined") return colours[colour.toLowerCase()];

    return colour;
}
